"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.X = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const X = () => {
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: "192", height: "192", fill: "currentcolor", viewBox: "0 0 256 256" }, { children: [(0, jsx_runtime_1.jsx)("line", { x1: "200", y1: "56", x2: "56", y2: "200", stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "16" }), (0, jsx_runtime_1.jsx)("line", { x1: "200", y1: "200", x2: "56", y2: "56", stroke: "currentcolor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "16" })] })));
};
exports.X = X;
